$(document).ready(function () {
    let savedEmails = [];

    $(document).on('nc.sidePanel.shown', function (e, result) {
        if (window.sidePanels.getCurrentSidePanel() !== undefined) {
            if ($('#dossier-requests-page').length) {
                initialize();
            }
        } else {
            console.log('dossier-request-type-select: Error getting side-panel');
        }
    });

    $(document).on('change', 'select[name="sign_contact_ids[]"]', function () {
        // get the id of the selected contact
        let contactIds = $(this).val();

        // if no contactIds array is empty, empty the email input
        if (contactIds.length === 0) {
            $('input[name="to"]').val('');
            return;
        }

        // get the email of the selected contacts
        $.ajax({
            url: '/admin/users/get-emails',
            type: 'GET',
            data: {
                contact_ids: contactIds
            },
            success: function (response) {
                if (response.success) {
                    // add the response data to the email input, dividing them with a ;
                    $('input[name="to"]').val(response.data.join(';'));
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    });

    function initialize() {
        window.sidePanels.getCurrentSidePanel().content.on('change', '#type', ($event) => {
            $event.stopImmediatePropagation();
            const value = $('#type').val();
            if (value === 'file') {
                // Enable these elements
                toggleElement($('#fileRequest'), false);
                // Disable these elements
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileAndProcess'), true);
                toggleElement($('#fileAndProcessWithPayment'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            } else if (value === 'questionnaire') {
                // Enable these elements
                toggleElement($('#questionnaireRequest'), false);
                // Disable these elements
                toggleElement($('#fileAndProcess'), true);
                toggleElement($('#fileAndProcessWithPayment'), true);
                toggleElement($('#fileRequest'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            } else if (value === 'file_and_process') {
                // Enable these elements
                toggleElement($('#fileAndProcess'), false);
                // Disable these elements
                toggleElement($('#fileAndProcessWithPayment'), true);
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileRequest'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            } else if (value === 'file_and_process_with_payment' || value === 'file_and_process_with_recurring_payment') {
                // Enable these elements
                toggleElement($('#fileAndProcessWithPayment'), false);
                // Disable these elements
                toggleElement($('#fileAndProcess'), true);
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileRequest'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            } else if (value === 'upload_and_view_file') {
                // Enable these elements
                toggleElement($('#fileAndProcess'), false);
                // Disable these elements
                toggleElement($('#fileAndProcessWithPayment'), true);
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileRequest'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            } else if (value === 'document_sign') {
                // Enable these elements
                toggleElement($('#documentSign'), false);
                // Disable these elements
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileRequest'), true);
                toggleElement($('#fileAndProcess'), true);
                toggleElement($('#fileAndProcessWithPayment'), true);

                disableEmailEditing(true);
            } else {
                // Enable these elements
                toggleElement($('#fileRequest'), false);
                // Disable these elements
                toggleElement($('#questionnaireRequest'), true);
                toggleElement($('#fileAndProcess'), true);
                toggleElement($('#fileAndProcessWithPayment'), true);
                toggleElement($('#documentSign'), true);

                disableEmailEditing(false);
            }
        });
        $('#type').change();
    }

    function toggleElement(element, disable = false) {
        // Toggle .dropdown-toggle between disabled and enabled
        if (disable) {
            element.addClass('d-none');
        } else {
            element.removeClass('d-none');
        }

        // Keep explicit disabling for folder selectors (redundant but harmless)
        element.find('[name="root_folder_id"]').prop("disabled", disable);
        element.find('[name="sub_folder_id"]').prop("disabled", disable);
        element.find('[name="folder_id"]').prop("disabled", disable);

        // Toggle .dropdown-toggle between disabled and enabled
        if (disable) {
            element.find('.dropdown-toggle').addClass("disabled");
        } else {
            element.find('.dropdown-toggle').removeClass("disabled");
        }
    }

    function disableEmailEditing(disable = false) {
        let emailInput = $('input[name="to"]');

        if (!disable) {
            emailInput.prop("readonly", false);
            // restore the saved email value
            if (savedEmails.length === 0) {
                return;
            }

            emailInput.val(savedEmails.pop());
            savedEmails = [];
        } else {
            emailInput.prop("readonly", true);
            // empty the email input and save the value to be restored later
            savedEmails.push(emailInput.val());
            emailInput.val('');
        }
    }
});
